var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    class: _vm.colorClass,
    attrs: {
      "no-block": true,
      "no-body": "no-body"
    }
  }, [_c('b-card-body', {
    staticClass: "pb-0"
  }, [(_vm.actions) ? _c('b-dropdown', {
    staticClass: "float-right",
    attrs: {
      "variant": "transparent p-0",
      "right": "right"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "icon-settings"
  })]), _vm._l((_vm.actions), function(action) {
    return _c('b-dropdown-item', {
      key: action.name
    }, [_vm._v(_vm._s(action.name))])
  })], 2) : _vm._e(), _c('h4', {
    staticClass: "mb-0"
  }, [_vm._t("default", [_vm._v("N/A")])], 2), _c('p', [_vm._v(_vm._s(_vm.category))]), _c('div', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "height": "70"
    }
  })], 1), _c('small', {
    staticClass: "py-1 px-3"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Synced")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6e000aa","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Statsbox.vue
// module id = 1385
// module chunks = 1